<div
  tuiDropdownOpen
  [tuiDropdown]="content">
  <tui-avatar
    appearance="user"
    size="s"
    class="cursor-pointer"
    [round]="false"
    [src]="userFullName() | tuiInitials"></tui-avatar>
</div>
<ng-template
  #content
  let-close>
  <tui-data-list role="menu">
    <button
      iconEnd="@tui.log-out"
      new
      tuiOption
      (click)="logout(); close()">
      Выйти
    </button>
  </tui-data-list>
</ng-template>
